import React from 'react';
import { Award, CheckCircle, XCircle, Eye } from 'lucide-react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

const AchievementApprovalsWidget = ({ achievements, userEmail, onRefresh }) => {
  const handleVerify = async (achievementId, status, reason = null) => {
    try {
      await updateDoc(doc(db, 'achievements', achievementId), {
        status: status,
        verifiedBy: userEmail,
        verificationDate: new Date(),
        rejectionReason: reason
      });
      alert(`Achievement ${status === 'verified' ? 'verified' : 'rejected'} successfully!`);
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to process achievement');
    }
  };

  if (achievements.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <CheckCircle className="w-12 h-12 mx-auto mb-2 text-gray-300" />
        <p>No pending verifications</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {achievements.map(achievement => (
        <div key={achievement.id} className="border rounded-lg p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-2">
                <span className="font-semibold text-blue-600">{achievement.rollNumber}</span>
                <span className="text-gray-600">|</span>
                <span className="text-gray-900">{achievement.studentName}</span>
              </div>
              <h4 className="font-semibold text-gray-900">{achievement.title}</h4>
              <p className="text-sm text-gray-600 mt-1">{achievement.description}</p>
              <div className="flex items-center space-x-3 mt-2 text-sm">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded">
                  {achievement.category}
                </span>
                <span className="text-gray-500">{achievement.subcategory}</span>
              </div>
            </div>
            {achievement.documentUrl && (
              <button
                onClick={() => window.open(achievement.documentUrl, '_blank')}
                className="ml-4 flex items-center space-x-2 px-3 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
              >
                <Eye className="w-4 h-4" />
                <span>View</span>
              </button>
            )}
          </div>
          
          <div className="flex space-x-2">
            <button
              onClick={() => handleVerify(achievement.id, 'verified')}
              className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              <CheckCircle className="w-4 h-4" />
              <span>Verify</span>
            </button>
            <button
              onClick={() => {
                const reason = prompt('Reason for rejection:');
                if (reason) handleVerify(achievement.id, 'rejected', reason);
              }}
              className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              <XCircle className="w-4 h-4" />
              <span>Reject</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AchievementApprovalsWidget;